// Registro mínimo (sin dependencias) de si el esqueleto de la ruta está —o recién
// estuvo— en pantalla. La pantalla que lo releva lo consulta para seguir mostrando su
// propio esqueleto sin el retardo anti-parpadeo de useSkeletonGate: ese retardo es para
// cargas que arrancan en blanco, no para continuar un esqueleto que ya se estaba viendo.
let mounted = 0;
let lastUnmountAt = -Infinity;
const HANDOFF_MS = 200;

export const routeSkeletonMounted = (): (() => void) => {
  mounted += 1;
  return () => {
    mounted -= 1;
    lastUnmountAt = performance.now();
  };
};

export const routeSkeletonOnScreen = (): boolean =>
  mounted > 0 || performance.now() - lastUnmountAt < HANDOFF_MS;
